import apiClient from './apiClient';

export interface QueryParams {
  report_type?: string;    // "vendor" or "vendor_product"
  date_from?: string;      // YYYY-MM-DD
  date_to?: string;        // YYYY-MM-DD
  vendor_from?: string;
  vendor_to?: string;
  product_from?: string;
  product_to?: string;
  dept_from?: string;
  dept_to?: string;
}

export interface StatRow {
  FD110_12: string;      // vendor code
  vendor_name: string;
  FD111_16: string;      // unit
  total_qty: number;
  total_amt: number;
  avg_price: number;
}

export interface ProductStatRow {
  FD110_12: string;      // vendor code
  vendor_name: string;
  FD111_10: string;      // product code 1
  FD111_11: string;      // product code 2
  product_code: string;  // concatenated
  product_desc: string;
  FD111_16: string;      // unit
  total_qty: number;
  total_amt: number;
  avg_price: number;
  FD111_51: string;
  FD111_52: string;
  FD111_53: number;
  FD111_54: number;
  FD111_55: number;
  FD111_56: number;
}

export interface VendorCount {
  code: string;
  name: string;
  count: number;
}

export interface UnitSummary {
  FD111_16: string;
  total_qty: number;
  total_amt: number;
  avg_price: number;
}

export interface VendorQueryResponse {
  report_type: string;
  data: StatRow[];
  count: number;
  group_counts: VendorCount[];
  unit_summary: UnitSummary[];
  message?: string;
}

export interface ProductQueryResponse {
  report_type: string;
  data: ProductStatRow[];
  count: number;
  group_counts: VendorCount[];
  unit_summary: UnitSummary[];
  message?: string;
}

export const d305Api = {
  async query(params: QueryParams): Promise<VendorQueryResponse | ProductQueryResponse> {
    const res = await apiClient.post('/api/d305/query', params);
    return res.data;
  },
  async lookupName(type: string, code: string): Promise<string> {
    if (!code?.trim()) return '';
    try {
      const res = await apiClient.get(`/api/d305/lookup/${encodeURIComponent(type)}/${encodeURIComponent(code.trim())}`);
      return res.data.name || '';
    } catch { return ''; }
  },
};
